<nav mat-tab-nav-bar class="responsive-nav">
    <a mat-tab-link [href]="navLinks[0].path">
        <img src="../../../assets/images/logo.png" alt="Home" />
    </a>
    @if (isLoggedIn()) {
    <button mat-button [matMenuTriggerFor]="menu">Menu</button>
    }
    <mat-menu #menu="matMenu">
        @for (link of navLinks | callbackFilter:filterNavigation; track link.path) {
        <button mat-menu-item [routerLink]="[link.path]" routerLinkActive="active-menu-item"
            [routerLinkActiveOptions]="{exact: true}" (click)="activeRouter(link)"
            (isActiveChange)="$event ? activeRouter(link) : null"> {{link.label}} </button>
        }
    </mat-menu>
    @if (isLoggedIn()) {
    <div class="vertical"></div>
    }
    @if (isLoggedIn()) {
    <button mat-button class="activeLabel">
        {{this.loginStateService.activeLabel}}
    </button>
    }

    <span class="spacer"></span>

    @if (isLoggedIn()) {
    <div class="buttons">
        <!-- Single Cascading Context Trigger -->
        <button mat-stroked-button class="context-trigger-btn" color="primary" [matMenuTriggerFor]="rootBrandMenu" [disabled]="loading"
            [matTooltip]="(currentBrand?.brand || 'Brand') + ' › ' + (currentFmSystemList?.name || 'FM') + ' › ' + getCurrentClientName()"
            matTooltipPosition="below">
            <span>{{ currentBrand?.brand || 'Brand' }}<span style="margin: 0 14px;">&rsaquo;</span>{{ currentFmSystemList?.name || 'FM' }}<span style="margin: 0 14px;">&rsaquo;</span>{{ getCurrentClientName() }}</span>
            <mat-icon>expand_more</mat-icon>
        </button>

        <!-- Level 1: Brand Menu -->
        <mat-menu #rootBrandMenu="matMenu" xPosition="after" yPosition="below" [overlapTrigger]="false" class="brand-menu-panel">
            @for (brand of allBrands; track brand.brand) {
            <button mat-menu-item [matMenuTriggerFor]="fmMenu" [matMenuTriggerData]="{ brand: brand }"
                (mouseenter)="loadFmSystems(brand.brand)">
                <span>{{ brand.brand }}</span>
            </button>
            } @empty {
            <button mat-menu-item disabled>No Brands available</button>
            }
        </mat-menu>

        <!-- Level 2: FM Systems Menu (Lazy-rendered via ng-template) -->
        <mat-menu #fmMenu="matMenu" xPosition="after" class="fm-menu-panel">
            <ng-template matMenuContent let-selectedBrand="brand">
                @if (loadingFm.get(selectedBrand.brand)) {
                <button mat-menu-item disabled>
                    <mat-spinner diameter="18"></mat-spinner>
                    <span style="margin-left: 8px;">Loading FM Systems...</span>
                </button>
                } @else {
                    @for (fm of getFmSystemsForBrand(selectedBrand); track fm.fmSystemId) {
                    <button mat-menu-item [matMenuTriggerFor]="clientMenu" [matMenuTriggerData]="{ brand: selectedBrand, fm: fm }"
                        (mouseenter)="loadClients(selectedBrand.brand, fm.fmSystemId)">
                        <span>{{ fm.name }}</span>
                    </button>
                    } @empty {
                    <button mat-menu-item disabled>No FM Systems available</button>
                    }
                }
            </ng-template>
        </mat-menu>

        <!-- Level 3: Client Menu (Lazy-rendered; clicking an option commits the change ONCE) -->
        <mat-menu #clientMenu="matMenu" class="client-menu-panel" xPosition="after" (closed)="clientSearchTerm = ''">
            <ng-template matMenuContent let-selectedBrand="brand" let-selectedFm="fm">
                @if (loadingClientsMap.get(selectedBrand.brand + '_' + selectedFm.fmSystemId)) {
                <button mat-menu-item disabled>
                    <mat-spinner diameter="18"></mat-spinner>
                    <span style="margin-left: 8px;">Loading Clients...</span>
                </button>
                } @else {
                    <div class="menu-search-container" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                        <mat-form-field appearance="outline" class="menu-search-field" subscriptSizing="dynamic">
                            <mat-icon matPrefix>search</mat-icon>
                            <input matInput [(ngModel)]="clientSearchTerm" placeholder="" autocomplete="off">
                            @if (clientSearchTerm) {
                            <button mat-icon-button matSuffix aria-label="Clear" (click)="clientSearchTerm = ''">
                                <mat-icon>close</mat-icon>
                            </button>
                            }
                        </mat-form-field>
                    </div>
                    <div class="client-list-container" style="max-height: 480px; overflow-y: auto;">
                        @for (client of getClientsForFm(selectedBrand.brand, selectedFm.fmSystemId, clientSearchTerm); track client.clientId) {
                        <button mat-menu-item (click)="applySelection(selectedBrand, selectedFm, client)">
                            <span class="client-name-text">{{ client.clientName }}</span>
                        </button>
                        } @empty {
                        <button mat-menu-item disabled>No Clients found</button>
                        }
                    </div>
                }
            </ng-template>
        </mat-menu>

        <div class="logout-button">
            <button mat-stroked-button color="primary" (click)="logout()">Log Out</button>
        </div>
    </div>
    }
</nav>

@if (loading) {
<div class="loading-shade">
    @if (loading) {
    <mat-spinner></mat-spinner>
    }
</div>
}